export default __webpack_public_path__ + "static/media/laRiojaIcono.ff4493af.jpg";